'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['#108cc0', '#DF4B25', '#FF9900', '#109618', '#990099', '#3B3EAC', '#0099C6', '#DD4477', '#66AA00', '#B82E2E', '#316395', '#994499', '#22AA99', '#AAAA11', '#6633CC', '#E67300', '#8B0707', '#329262', '#5574A6', '#3baca0'];
var geographyColors = exports.geographyColors = ['#f5f5f5', '#108cc0'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Chart/chart-colors.js
// module id = 513
// module chunks = 1